<template>
  <div>
    <div class="row gy-5 g-xl-8">
      <div class="mb-0" :class="{ 'mt-0': !dialog }">
        <div class="py-3 pt-0">
          <Paginacao
            ref="paginacao"
            :center="true"
            :total="itensTotal"
            :limit="5"
            @change-pagina="carregarItens()"
          />
          <div class="table-responsive">
            <table
              class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
            >
              <thead>
                <tr class="fw-bolder text-dark">
                  <th style="width: 80px" class="text-start">
                    Criado em ({{ itensTotal }})
                  </th>
                  <th style="width: 80px" class="text-start">Expirar em</th>
                  <th style="width: 150px" class="text-start">Usuário</th>
                  <th style="width: 100px" class="text-start">Arquivo</th>
                  <th style="width: 100px" class="text-center">Senha</th>
                  <th class="w-40px text-end">Opções</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in itens" :key="item._id" :item="item">
                  <td class="text-start">
                    <span
                      class="text-start text-dark fw-bold d-block fs-7 mt-1"
                    >
                      {{ $funcoes.formatarDataHora(item.data) }}
                    </span>
                  </td>
                  <td class="text-start">
                    <span
                      class="text-start text-dark fw-bold d-block fs-7 mt-1"
                    >
                      {{ $funcoes.formatarDataHora(item.expirou) }}
                    </span>
                  </td>
                  <td class="text-start">
                    <div
                      class="d-flex align-items-center"
                      v-if="usuarios[item.usuario]"
                    >
                      <div class="d-flex justify-content-start flex-column">
                        <span class="text-dark fw-bolder fs-6">
                          {{ usuarios[item.usuario].nome }}
                        </span>
                        <span class="text-muted fw-bold d-block fs-7">{{
                          usuarios[item.usuario].nomeUsuario
                        }}</span>
                      </div>
                    </div>
                  </td>
                  <td class="text-start">
                    <span class="text-muted fw-bold text-muted d-block fs-7">{{
                      item.nome + item.tipo
                    }}</span>
                  </td>
                  <td class="text-center">
                    <span
                      class="badge badge-light-danger"
                      v-if="item.senha !== ''"
                      >Fechado</span
                    >
                    <span
                      class="badge badge-light-success"
                      v-if="item.senha == ''"
                      >Aberto</span
                    >
                  </td>
                  <td>
                    <div class="d-flex justify-content-end flex-shrink-0">
                      <button
                        class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2"
                        data-bs-toggle="tooltip2"
                        data-bs-placement="top"
                        title="Excluir"
                        data-bs-original-title="Excluir"
                        aria-label="Excluir"
                        @click="excluirMensagem(item.key)"
                      >
                        <span class="svg-icon svg-icon-3"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-trash"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"
                            />
                            <path
                              fill-rule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                            /></svg
                        ></span>
                      </button>
                      <button
                        class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                        data-bs-toggle="tooltip2"
                        data-bs-placement="top"
                        title="Editar"
                        @click="editarItem(item.key)"
                      >
                        <span class="svg-icon svg-icon-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              opacity="0.3"
                              d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                              fill="currentColor"
                            ></path>
                            <path
                              d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                              fill="currentColor"
                            ></path>
                          </svg>
                        </span>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <LinkOpcoesDialog
      ref="formDownloadEdit"
      view="modal"
      @save-item="carregarItens()"
      @dialog-on="
        if (this.dialog) {
          $emit('dialog-on');
        }
      "
      @dialog-off="
        if (this.dialog) {
          $emit('dialog-off');
        }
      "
    />

    <DialogMensagem
      ref="dialogExcluir"
      titulo="Excluir"
      mensagem="Deseja excluir o link ?"
      classBody="mx-5 mx-xl-15 my-1 text-center"
      @dialog-on="
        if (this.dialog) {
          $emit('dialog-on');
        }
      "
      @dialog-off="
        if (this.dialog) {
          $emit('dialog-off');
        }
      "
      @confirmar="excluirItem()"
    />
  </div>
</template>

<script>
import { api } from "@/plugins/api.js";

import { useAuthStore } from "@/stores/auth.js";

import DialogMensagem from "../components/ComponentDialogMensagem.vue";

import LinkOpcoesDialog from "./LinkOpcoesDialog.vue";

import Paginacao from "../components/ComponentPaginacao.vue";

export default {
  components: { Paginacao, LinkOpcoesDialog, DialogMensagem },
  props: {
    dialog: { type: Boolean, default: false }
  },
  data() {
    return {
      itemExcluir: null,
      timerFiltroTexto: null,
      itensTotal: 0,
      filtroTexto: "",
      ordem: "data_DESC",
      itens: [],
      usuarios: {}
    };
  },

  setup() {
    const storeAuth = useAuthStore();
    return { storeAuth };
  },

  mounted() {},

  watch: {},

  methods: {
    async carregarItens() {
      let filtros = "";

      filtros += "?_limit=" + 5;
      filtros += "&_page=" + this.$refs.paginacao.pagina;
      filtros += "&_ordem=" + this.ordem;

      //* Carrega os dados dos usuarios possiveis
      this.carregarUsuarios();

      //* Carrega as atividades
      const response = await api.get(
        this.storeAuth.apiNuvem() + "/download/request" + filtros
      );

      api.valid(response.data, this.$router);

      this.itens = response.data.itens;
      this.itensTotal = response.data.total;
    },
    async carregarUsuarios() {
      this.usuarios = await api.getItensObjectId(
        window._env_.VUE_APP_URL_API + "/admin/usuario"
      );
    },
    editarItem(key) {
      this.$refs.formDownloadEdit.abrir(key);
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      const obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        //obj.$refs.paginacao.pagina = 1;
        obj.carregarItens();
      }, 300);
    },
    excluirMensagem(key) {
      this.itemExcluir = key;
      this.$refs.dialogExcluir.abrir();
    },
    async excluirItem() {
      //* Excluir o backuo
      const response = await api.put(
        this.storeAuth.apiNuvem() +
          "/download/request/excluir/" +
          this.$funcoes.customEncodeURIComponent(this.itemExcluir),
        {}
      );

      //* Recarrega os itens
      this.carregarItens();
    }
  }
};
</script>

<style></style>
